export default __webpack_public_path__ + "static/media/yei.1b186072.svg";